<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
    <div class="lockscreen  mt-5 mb-5">
      <div class="px-6 mb-0 py-12 text-center theme-background rounded-lg">
        <h1 class="display-3 font-weight-bold">404</h1>
        <h5><i class="ion ion-alert pr-2"></i>Oops! Something went wrong</h5>
        <p>
          The page you are looking for is not found, please try after some time
          or go back to home
        </p>
      <vs-button class="mt-3"> Go To Home </vs-button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    document.body.classList.add("bg-primary", "404");
  },
  destroyed() {
    document.body.classList.remove("bg-primary", "404");
  },
};
</script>
